import { isInMccmApp } from "@mgdx/shared/src/utils/isInMccmApp";
import { useMemo } from "react";

export const useIsInMccmApp = () => useMemo(() => isInMccmApp(), []);
